var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible || _vm.localVisible),expression:"visible || localVisible"}],staticClass:"loading"},[_c('b-spinner',{staticClass:"spinner",attrs:{"label":"Loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }